import { reactive } from 'vue'
import { io } from 'socket.io-client'

import Constants from '@helpers/Constants'
import { useMeteoVariablesStore } from 'src/stores/meteoVariables'
import { useDownloadsStore } from '@stores/downloadsStore'
import { useSimulationStore } from '@stores/simulationStore'
import { ProgressMediaResponseDTO } from '@models/api/ProgressMediaResponseDTO'
import { SimulateStatusUpdateEvent } from '@models/simulation/SimulateStatusUpdateEvent'

export const state = reactive({
  connected: false,
  fooEvents: [] as any,
  barEvents: [] as any
})

export const socket = io(Constants.baseURL, { autoConnect: false })

socket.on('connect', () => {
  state.connected = true
})

socket.on('disconnect', () => {
  state.connected = false
})

socket.on('foo', (...args: any) => {
  state.fooEvents.push(args)
})

socket.on('bar', (...args: any) => {
  state.barEvents.push(args)
})

socket.on('updateModels', () => {
  useMeteoVariablesStore().fetchVariables()
})

socket.on(
  'progress_download',
  (
    result: Stringified<ProgressMediaResponseDTO> | ProgressMediaResponseDTO
  ) => {
    if (typeof result === 'string') {
      try {
        result = JSON.parse(result)
      } catch (error) {
        console.error('Error parsing progress_download result:', error)
        return
      }
    }
    const resultParsed = result as ProgressMediaResponseDTO
    useDownloadsStore().updateDownloadStatus(resultParsed)
  }
)

socket.on('sim-status-update', (event: string) => {
  const eventParsed = JSON.parse(event) as SimulateStatusUpdateEvent
  useSimulationStore().UPDATE_SIMULATION_STATUS(eventParsed)
})
